import { HelmetDexteel, useUserContext } from "@dexteel/mesf-core";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { TaskListProvider } from "./context/taskListContext";
import { useInitialValues } from "./filters/hooks/useInitialValues";
import { TaskListByAreas } from "./task-list-by-area/task-list-by-area";
import { TaskListbyDownHours } from "./task-list-by-down-hours/task-list-by-down-hours";

export default function TaskListIndex() {
	const { AssetIdParam } = useParams();
	const navigate = useNavigate();
	const location = useLocation();

	const {
		state: { defaultAreaId },
	} = useUserContext();

	useInitialValues();

	const isDowndayRoute = location.pathname.includes("/downday");
	const isAreaRoute = location.pathname.includes("/area");

	if (!AssetIdParam) {
		if (isAreaRoute) {
			navigate(`/task-list/area/${defaultAreaId}`, { replace: true });
			return null;
		} else if (isDowndayRoute) {
			navigate(`/task-list/downday/${defaultAreaId}`, { replace: true });
			return null;
		} else {
			navigate(`/task-list/area/${defaultAreaId}`, { replace: true });
			return null;
		}
	}

	if (isAreaRoute) {
		return (
			<>
				<HelmetDexteel title="Task List" />
				<TaskListProvider>
					<TaskListByAreas />
				</TaskListProvider>
			</>
		);
	} else if (isDowndayRoute) {
		return (
			<>
				<HelmetDexteel title="Task List" />
				<TaskListProvider>
					<TaskListbyDownHours />
				</TaskListProvider>
			</>
		);
	}

	// Default fallback to area view
	return (
		<>
			<HelmetDexteel title="Task List" />
			<TaskListProvider>
				<TaskListByAreas />
			</TaskListProvider>
		</>
	);
}
